import { AxiosError, AxiosResponse } from 'axios';
import { useSnackbar } from 'notistack';
import { useCallback, useContext } from 'react';
import PlansContext from 'src/contexts/PlansContext';
import { AsyncPlanningResponseEntity } from 'src/entities/planningResponseEntity';

import { useScenarioPlanningV5 } from './useQueryPlanning';

interface ScenarioPlanningRequestHookParams {
  dispatchPlanning?: (action: { type: string }) => void;
  setAsyncPlanningResponse: (response: AsyncPlanningResponseEntity | null) => void;
  resetQuery: () => void;
}

export const useScenarioPlanningRequestV5 = ({
  dispatchPlanning,
  setAsyncPlanningResponse,
  resetQuery,
}: ScenarioPlanningRequestHookParams) => {
  const plansContext = useContext(PlansContext);
  const { startOn, endOn, refreshRunningEntities, handleErrorResponse, } = plansContext;

  const { enqueueSnackbar } = useSnackbar();
  const { scenarioPlanning } = useScenarioPlanningV5();

  const requestScenarioPlanning = useCallback((scenarioId: number) => {
    scenarioPlanning.mutate({ scenarioId, startOn, endOn }, {
      onSuccess: (data: AxiosResponse<AsyncPlanningResponseEntity>) => {
        dispatchPlanning({
          type: 'resetRestrictedInsertPosition',
        });
        if (data.data.status === 'queued') {
          const entity: AsyncPlanningResponseEntity = data.data;
          setAsyncPlanningResponse(entity);
          enqueueSnackbar('自動配車を実行中です。完了までしばらくお待ち下さい。');
          refreshRunningEntities();
        } else {
          enqueueSnackbar('シナリオ実行に失敗しました');
        }
      },
      onError: (e: AxiosError<{ message: string; }>) => {
        handleErrorResponse(e, resetQuery);
      },
    });
  }, [dispatchPlanning, endOn, enqueueSnackbar, handleErrorResponse, refreshRunningEntities, resetQuery, scenarioPlanning, setAsyncPlanningResponse, startOn]);

  return { requestScenarioPlanning };
};
